import type { FC } from 'react';
import track from 'react-tracking';
import Media from 'react-media';
import {
  TopShareholdersTable,
  TopShareholdersAccordion,
  ShareholderWithTitle,
} from '@company/components/Ownership';
import { useTheme } from '@simplywallst/ui-core';
import { ShareholdersWrapper } from './styled';
import { ViewMode } from '@/components/Company/enum';

export interface TopShareholdersProps {
  topShareholders: ShareholderWithTitle[];
  viewMode: ViewMode;
}

const TopShareholders: FC<TopShareholdersProps> = ({
  topShareholders,
  viewMode,
}) => {
  const theme = useTheme();
  return (
    <ShareholdersWrapper>
      <Media query={{ minWidth: theme.mdMinRaw }}>
        {(matches) =>
          matches || viewMode === ViewMode.Print ? (
            <TopShareholdersTable topShareholders={topShareholders} />
          ) : (
            <TopShareholdersAccordion topShareholders={topShareholders} />
          )
        }
      </Media>
    </ShareholdersWrapper>
  );
};

export default track(({ topShareholders }) => ({
  type: 'track',
  subject: 'topShareholders',
  listLength: topShareholders.length,
}))(TopShareholders) as typeof TopShareholders;
